import { Injectable, OnDestroy, Renderer2, RendererFactory2 } from '@angular/core'
import {
  BasePageMetaResolver,
  CmsService,
  Page,
  PageLinkService,
  PageRobotsMeta,
  RoutingPageMetaResolver,
  TranslationService,
  WindowRef
} from '@spartacus/core'
import { Router } from '@angular/router'
import { MbConstants } from '../../shared/mb-constants'
import { Subscription } from 'rxjs'
import { PageNotFoundMetaTagResolver } from './page.resolvers'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MbBasePageMetaResolver extends BasePageMetaResolver implements PageNotFoundMetaTagResolver, OnDestroy {

  renderer: Renderer2
  appendedNotFoundMetaTag: boolean = false
  subscription: Subscription = new Subscription()

  constructor (cmsService: CmsService,
               translation: TranslationService,
               routingPageMetaResolver: RoutingPageMetaResolver,
               router: Router,
               pageLinkService: PageLinkService,
               private winRef: WindowRef,
               private renderFactory: RendererFactory2) {
    super(cmsService, translation, routingPageMetaResolver, router, pageLinkService)

    this.renderer = renderFactory.createRenderer(null, null)
    this.resolveNotFoundMetaTag()
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  resolveRobots () {
    return this.cmsService.getCurrentPage().pipe(
      map(page => {
        if (this.router.url.split('/')?.[0]?.includes(MbConstants.FALLBACK_COUNTRY)) {
          return [PageRobotsMeta.NOFOLLOW, PageRobotsMeta.NOINDEX]
        }
        if (page?.robots) {
          return page.robots
        }
        return []
      })
    )
  }

  resolveNotFoundMetaTag () {
    this.subscription.add(this.page$.subscribe((page: Page) => {
      let meta: HTMLMetaElement
      if (page?.pageId === 'notFound') {
        if (!this.appendedNotFoundMetaTag) {
          meta = this.renderer.createElement('meta')
          meta.content = '404'
          meta.name = 'prerender-status-code'
          this.renderer.appendChild(this.winRef.document?.head, meta)
          this.appendedNotFoundMetaTag = true
        }
      } else {
        if (this.appendedNotFoundMetaTag) {
          meta = this.renderer.selectRootElement('meta[name="prerender-status-code"]', true)
          this.renderer.removeChild(this.winRef.document?.head, meta)
          this.appendedNotFoundMetaTag = false
        }
      }
    }))
  }
}
